import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

import Footer from '@app/components/UI/Footer/Footer';
import HeaderNew from '@app/components/UI/Header/HeaderNew';
import { ApplicationState } from '@app/store';

import '@app/scss/style.scss';

const LayoutPrivate: React.FC = () => {
	const login = useSelector((state: ApplicationState) => state.login, shallowEqual);
	const navigate = useNavigate();

	React.useEffect(() => {
		if (!login.user) {
			return navigate('/');
		}
	}, [login.user]);

	return (
		<div className="app-container">
			<HeaderNew />
			<Outlet />
			<Footer />
		</div>
	);
};

export default LayoutPrivate;
